/**
 * Gemini: Saved info has no export (paste lane covers it); the file lane is
 * the Gemini CLI's `GEMINI.md` context files.
 */
import { chunkMarkdown } from '../chunk.js';
import type { MemoryImportItem, NamedText } from '../types.js';
import { epistemicForHeading } from './generic.js';
import { basename } from './util.js';

export function parseGemini(files: NamedText[]): MemoryImportItem[] {
  const items: MemoryImportItem[] = [];
  for (const file of files) {
    if (basename(file.name).toLowerCase() !== 'gemini.md') continue;
    items.push(...chunkMarkdown(file.text, basename(file.name), { epistemic: 'preference', epistemicForHeading }));
  }
  return items;
}
